import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Content = _resolveComponent("Content")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode(_component_Content, {
      SmartDevices: _ctx.SmartDevices,
      onDeviceId: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDevice($event)))
    }, null, 8, ["SmartDevices"]),
    (_ctx.dialog)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog($event))),
          deviceToDisplay: _ctx.deviceToDisplay,
          onChangeBright: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeBright($event))),
          onDisconnect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.disconnect($event))),
          onConnect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.connect($event))),
          onColor: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setColor($event))),
          onTempChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tempChange($event)))
        }, null, 8, ["deviceToDisplay"]))
      : _createCommentVNode("", true)
  ]))
}